import React, { useState, useEffect, useRef } from "react";
import CustomTooltip from "./CustomTooltip";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./../assets/css/nucleo-icons.css";
import "./../assets/css/soft-ui-dashboard.css";
import "./../assets/css/nucleo-svg.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CONSTANTS from "../util/constants";
import { useDispatch, useSelector } from "react-redux";
import MovesModalComponent from "./MovesModalComp";
import DataTable from "react-data-table-component";
import CommentModalComp from "./CommentModalComp";
import Encrypt from "./../util/encrypt";

const MovesComp = () => {
  const gridRef = useRef();
  const [rowDataCompleted, setRowDataCompleted] = useState([]);
  const [rowDataPending, setRowDataPending] = useState([]);
  const [rowDataInProgress, setRowDataInProgress] = useState([]);
  const [rowDataCancelled, setRowDataCancelled] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [key, setKey] = useState("PendingRequest");
  const [keyData, setKeyData] = useState("PendingRequest");
  const [keyTitle, setKeyTitle] = useState(1);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isUpdateMove, setIsUpdate] = useState(false);
  const [isCommentModalShow, setIsCommentModalShow] = useState(false);
  const getMoveDatTemp = useSelector((state) => state.move.getMoveData);
  const getMoveData = useSelector((state) => state.move.getMoveData?.rows);
  const moveCount = useSelector((state) => state.move.getMoveData?.count);
  const userRoles = useSelector((state) => state.login.loginRolesData);
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );
  const dispatch = useDispatch();
  const [rowId, setRowId] = useState(0);
  const [modalShow, isModalShow] = useState(false);
  const [cellData, setCellClickData] = useState(null);
  const [loginResponse, setLoginResponse] = useState(null);

  const cellCancelImageRender = (params) => {
    //update move
    return loginResponse &&
      ((loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
        loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
          loginResponse?.user?.userRoles[0]?.priority) ||
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
          loginResponse?.user?.userRoles[0]?.priority)) ? (
      <div
        className="me-2"
        onClick={() => {
          setTitle("Update Move");
          setKeyTitle(3);
          setCellClickData(params.data);
          showModal(true);
          setIsUpdate(false);
        }}
      >
        <img
          src={require("./../assets/Dashboard/rotate.png")}
          style={{ height: 24, width: 24 }}
        />
      </div>
    ) : null;
  };

  const cellImageRender = (params) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          onClick={() => {
            setCellClickData(params.data);
          }}
        >
          <img src={require("./../assets/Dashboard/comment.png")} />
        </div>
      </div>
    );
  };

  const cellMoveInImageRender = (params) => {
    if (!params.completed || !params.pending) {
      setCellClickData(params);

      return (
        <div className="me-2" onClick={() => {}}>
          {loginResponse &&
          ((loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
              loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
              loginResponse?.user?.userRoles[0]?.priority)) ? (
            params.pending ? (
              <img
                onClick={() => {
                  setTitle("Move to In Progress Request");
                  setKeyTitle(1);
                  setKeyData("PendingRequest");
                  showModal(true);
                }}
                src={require("./../assets/Dashboard/move.png")}
                style={{ height: 24, width: 24 }}
              />
            ) : (
              <img
                onClick={() => {
                  setTitle("Move to Complete Request");
                  setKeyTitle(2);
                  setKeyData("InProgressRequest"); //in In Progress section
                  showModal(true);
                }}
                src={require("./../assets/Dashboard/checkComplete.png")}
                style={{ height: 24, width: 24 }}
              />
            )
          ) : null}
        </div>
      );
    } else {
      return;
    }
  };

  const columnDefsPending = [
    {
      name: "Move Number",
      selector: (row, index) => {
        return index + 1;
      },
      disableSortBy: true,
    },
    {
      name: "Request Date Time",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.createdAt
          ? new Date(params.createdAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },

    {
      name: "Requester",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.requesterName;
      },
    },
    {
      name: "Move Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.changeType;
      },
    },
    {
      name: "Division",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.division?.divisionName
          ? params.division?.divisionName
          : "";
      },
    },
    {
      name: "Door Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let doorType = "---";
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOORIN" &&
          params?.doorTo != null
        ) {
          doorType = params?.doorTo?.doorType + "_" + params?.doorTo?.number;
        }
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOR2DOOR" &&
          (params?.doorTo != null || params?.doorFrom != null)
        ) {
          doorType =
            (params?.doorTo != null ? params?.doorTo?.doorType + "_" : "") +
            params?.doorFrom?.number +
            (params?.doorTo != null ? "_" + params?.doorTo?.number : "");
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOROUT" &&
          params?.doorFrom != null
        ) {
          doorType =
            params?.doorFrom?.doorType + "_" + params?.doorFrom?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "SPACE2SPACE"
        ) {
          doorType =
            (params?.lotFrom != null
              ? (params?.lotFrom?.lotName || "") +
                "_" +
                (params?.spaceFrom?.btId || "") +
                "->"
              : "UNKNOWN ->") +
            (params?.lotTo != null
              ? (params?.lotTo?.lotName || "") +
                "_" +
                (params?.spaceTo?.btId || "")
              : "UNKNOWN");
        }
        return doorType;
      },
    },

    {
      name: "Department",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.department ? params.department : "--";
      },
    },

    {
      name: "Trailer No",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.trailer?.btId
          ? params.trailer.btId
          : params.outsideCarrierContainer?.btId
          ? params.outsideCarrierContainer.btId + " Container"
          : params.trailer == null && params.isEmpty
          ? "Empty Trailer"
          : "";
      },
    },

    {
      name: "Driver",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.driver_id != null
          ? params.driver?.firstName + " " + params.driver?.lastName
          : "";
      },
    },

    {
      name: "Truck",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.truck_id != null ? params.truck?.type : "";
      },
    },

    {
      width: "6rem",
      name: "Comment",
      tooltipField: "beforeComments",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
      tooltipComponent: CustomTooltip,
      cell: (row) =>
        row?.beforeComments != "" && row?.beforeComments != null ? (
          <div
            onClick={() => {
              setIsCommentModalShow(true);
              setCellClickData(row);
            }}
          >
            <img src={require("./../assets/Dashboard/comment.png")} />
          </div>
        ) : null,
    },

    {
      width: "6rem",
      name:
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
            loginResponse?.user?.userRoles[0]?.priority))
          ? "Delete Move"
          : "",

      filter: true,
      resizable: true,
      flex: 1,
      cell: (row) =>
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
            loginResponse?.user?.userRoles[0]?.priority)) ? (
          <div
            onClick={() => {
              deleteEmptyTrailerMove(row);
            }}
          >
            <img
              style={{ marginLeft: 20 }}
              src={require("./../assets/Dashboard/cancel.png")}
            />
          </div>
        ) : null,
    },

    {
      name:
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority))
          ? "Update Move"
          : "",
      width: "6rem",
      tooltipField: "update",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellCancelImageRender,

      cell: (row) =>
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority)) ? (
          <div
            className="me-2"
            onClick={() => {
              setCellClickData(row);
              setTitle("Update Move");
              setKeyTitle(3);
              setIsUpdate(true);
              showModal(true);
            }}
          >
            <img
              src={require("./../assets/Dashboard/rotate.png")}
              style={{ height: 24, width: 24 }}
            />
          </div>
        ) : null,
    },

    {
      width: "10rem",
      name:
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority))
          ? keyData?.toLowerCase() == "pendingrequest"
            ? "Move To InProgress"
            : keyData?.toLowerCase() == "inprogressrequest"
            ? "Move To Complete"
            : ""
          : "",
      tooltipField: "completed",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellMoveInImageRender,
      cell: (row) =>
        !row.completed || !row.pending ? (
          <div className="me-2" onClick={() => {}}>
            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <img
                onClick={() => {
                  setCellClickData(row);
                  setIsUpdate(false);
                  setTitle("Move to InProgress Request");
                  setKeyTitle(1);
                  setKeyData("PendingRequest");
                  showModal(true);
                }}
                src={require("./../assets/Dashboard/move.png")}
                style={{ height: 24, width: 24 }}
              />
            ) : null}
          </div>
        ) : null,
    },
  ];

  const columnDefsInProg = [
    {
      name: "Move Number",
      selector: (row, index) => {
        return index + 1;
      },
      disableSortBy: true,
    },
    {
      name: "Request Date Time",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.createdAt
          ? new Date(params.createdAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      name: "Requester",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.requesterName;
      },
    },
    {
      name: "Move Type",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.changeType;
      },
    },
    {
      name: "Division",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.division?.divisionName
          ? params.division.divisionName
          : "";
      },
    },
    {
      name: "Door Type",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let doorType = "---";
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOORIN" &&
          params?.doorTo != null
        ) {
          doorType = params?.doorTo?.doorType + "_" + params?.doorTo?.number;
        }
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOR2DOOR" &&
          (params?.doorTo != null || params?.doorFrom != null)
        ) {
          if (params?.doorTo != null) {
            doorType =
              params?.doorTo?.doorType +
              "_" +
              params?.doorTo?.number +
              "_" +
              params?.doorTo?.number;
          } else {
            doorType =
              params?.doorFrom?.doorType +
              "_" +
              params?.doorFrom?.number +
              "_" +
              params?.doorFrom?.number;
          }
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOROUT" &&
          params?.doorFrom != null
        ) {
          doorType =
            params?.doorFrom?.doorType + "_" + params?.doorFrom?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "SPACE2SPACE"
        ) {
          doorType =
            (params?.lotFrom != null
              ? (params?.lotFrom?.lotName || "") +
                "_" +
                (params?.spaceFrom?.btId || "") +
                "->"
              : "UNKNOWN ->") +
            (params?.lotTo != null
              ? (params?.lotTo?.lotName || "") +
                "_" +
                (params?.spaceTo?.btId || "")
              : "UNKNOWN");
        }
        return doorType;
      },
    },
    {
      name: "Department",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.department ? params.department : "--";
      },
    },
    {
      name: "Trailer No",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.trailer?.btId
          ? params.trailer.btId
          : params.outsideCarrierContainer?.btId
          ? params.outsideCarrierContainer.btId + " Container"
          : params.trailer == null && params.isEmpty
          ? "Empty Trailer"
          : "";
      },
    },
    {
      name: "Driver",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.driver_id != null
          ? params.driver?.firstName + " " + params.driver?.lastName
          : "";
      },
    },
    {
      name: "Truck",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.truck_id != null ? params.truck?.type : "";
      },
    },
    {
      name: "Comment",
      width: "6rem",
      tooltipField: "beforeComments",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
      tooltipComponent: CustomTooltip,
      cell: (row) =>
        row?.beforeComments != "" && row?.beforeComments != null ? (
          <div
            onClick={() => {
              setIsCommentModalShow(true);
              setCellClickData(row);
            }}
          >
            <img src={require("./../assets/Dashboard/comment.png")} />
          </div>
        ) : null,
    },
    {
      name:
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
            loginResponse?.user?.userRoles[0]?.priority))
          ? "Update Move"
          : "",
      width: "6rem",
      tooltipField: "update",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellCancelImageRender,

      cell: (row) =>
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
            loginResponse?.user?.userRoles[0]?.priority)) ? (
          <div
            className="me-2"
            onClick={() => {
              setCellClickData(row);
              setTitle("Update Move");
              setKeyTitle(3);
              setIsUpdate(true);
              showModal(true);
            }}
          >
            <img
              src={require("./../assets/Dashboard/rotate.png")}
              style={{ height: 24, width: 24 }}
            />
          </div>
        ) : null,
    },
    {
      width: "10rem",
      name:
        loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
            loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
            loginResponse?.user?.userRoles[0]?.priority))
          ? "Move To Complete"
          : "",
      tooltipField: "completed",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellMoveInImageRender,
      cell: (row) =>
        !row.completed || !row.pending ? (
          <div className="me-2" onClick={() => {}}>
            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.DRIVER &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <img
                onClick={() => {
                  setCellClickData(row);
                  setIsUpdate(false);
                  setKeyTitle(2);
                  setTitle("Move to Complete Request");
                  setKeyData("InProgressRequest"); //in In Progress section
                  showModal(true);
                }}
                src={require("./../assets/Dashboard/checkComplete.png")}
                style={{ height: 24, width: 24 }}
              />
            ) : null}
          </div>
        ) : null,
    },
  ];

  const [columnDefs, setColumnDefs] = useState([]);
  const [columnDefsInProgress, setColumnDefsInProgress] = useState([]);
  const [columnCompletedDefs, setColumnDefsCompleted] = useState([
    {
      name: "Move Number",
      selector: (row, index) => {
        return index + 1;
      },
      disableSortBy: true,
    },
    {
      name: "Request Date Time",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.createdAt
          ? new Date(params.createdAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      name: "Completed Date Time",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.updatedAt
          ? new Date(params.updatedAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },

    {
      name: "Requester",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.requesterName;
      },
    },
    {
      name: "Move Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.changeType;
      },
    },

    {
      name: "Division",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.division?.divisionName
          ? params.division?.divisionName
          : "";
      },
    },

    {
      name: "Door Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let doorType = "---";
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOORIN" &&
          params?.doorTo != null
        ) {
          doorType = params?.doorTo?.doorType + "_" + params?.doorTo?.number;
        }
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOR2DOOR" &&
          (params?.doorTo != null || params?.doorFrom != null)
        ) {
          doorType =
            params?.doorTo?.doorType +
            "_" +
            params?.doorFrom?.number +
            "_" +
            params?.doorTo?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOROUT" &&
          params?.doorFrom != null
        ) {
          doorType =
            params?.doorFrom?.doorType + "_" + params?.doorFrom?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "SPACE2SPACE"
        ) {
          doorType =
            (params?.lotFrom != null
              ? (params?.lotFrom?.lotName || "") +
                "_" +
                (params?.spaceFrom?.btId || "") +
                "->"
              : "UNKNOWN ->") +
            (params?.lotTo != null
              ? (params?.lotTo?.lotName || "") +
                "_" +
                (params?.spaceTo?.btId || "")
              : "UNKNOWN");
        }
        return doorType;
      },
    },

    {
      name: "Department",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.department ? params.department : "--";
      },
    },

    {
      name: "Trailer No",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.trailer?.btId
          ? params.trailer.btId
          : params.outsideCarrierContainer?.btId
          ? params.outsideCarrierContainer.btId + " Container"
          : "";
      },
    },

    {
      name: "Driver",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.driver_id != null
          ? params.driver?.firstName + " " + params.driver?.lastName
          : "";
      },
    },

    {
      name: "Truck",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.truck_id != null ? params.truck?.type : "";
      },
    },

    {
      width: "6rem",
      name: "Comment",
      tooltipField: "afterComments",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
      tooltipComponent: CustomTooltip,
      cell: (row) =>
        row?.afterComments != "" && row?.afterComments != null ? (
          <div
            onClick={() => {
              setIsCommentModalShow(true);
              setCellClickData(row);
            }}
          >
            <img src={require("./../assets/Dashboard/comment.png")} />
          </div>
        ) : null,
    },
  ]);

  const [columnCancelledDefs, setColumnDefsCancelled] = useState([
    {
      name: "Move Number",
      selector: (row, index) => {
        return index + 1;
      },
      disableSortBy: true,
    },
    {
      name: "Request Flag",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let requestFlag = params?.requestFlag ? params?.requestFlag : "";
        return requestFlag;
      },
    },
    {
      name: "Request Date Time",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let myDate = params?.createdAt
          ? new Date(params.createdAt)
          : new Date();
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },

    {
      name: "Requester",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.requesterName;
      },
    },
    {
      name: "Move Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.changeType;
      },
    },

    {
      name: "Division",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.division?.divisionName
          ? params.division?.divisionName
          : "";
      },
    },

    {
      name: "Door Type",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let doorType = "---";
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOORIN" &&
          params?.doorTo != null
        ) {
          doorType = params?.doorTo?.doorType + "_" + params?.doorTo?.number;
        }
        if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOR2DOOR" &&
          (params?.doorTo != null || params?.doorFrom != null)
        ) {
          doorType =
            params?.doorTo?.doorType +
            "_" +
            params?.doorFrom?.number +
            "_" +
            params?.doorTo?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "DOOROUT" &&
          params?.doorFrom != null
        ) {
          doorType =
            params?.doorFrom?.doorType + "_" + params?.doorFrom?.number;
        } else if (
          params.changeType != null &&
          params.changeType != "" &&
          params.changeType == "SPACE2SPACE"
        ) {
          doorType =
            (params?.lotFrom != null
              ? (params?.lotFrom?.lotName || "") +
                "_" +
                (params?.spaceFrom?.btId || "") +
                "->"
              : "UNKNOWN ->") +
            (params?.lotTo != null
              ? (params?.lotTo?.lotName || "") +
                "_" +
                (params?.spaceTo?.btId || "")
              : "UNKNOWN");
        }
        return doorType;
      },
    },

    {
      name: "Department",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.department ? params.department : "--";
      },
    },

    {
      name: "Trailer No",
      width: "10rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.trailer?.btId
          ? params.trailer.btId
          : params.outsideCarrierContainer?.btId
          ? params.outsideCarrierContainer.btId + " Container"
          : "";
      },
    },

    {
      name: "Driver",
      width: "8rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.driver_id != null
          ? params.driver?.firstName + " " + params.driver?.lastName
          : "";
      },
    },

    {
      name: "Truck",
      width: "6rem",
      filter: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        return params?.truck_id != null ? params.truck?.type : "";
      },
    },

    {
      width: "6rem",
      name: "Comment",
      tooltipField: "afterComments",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellImageRender,
      tooltipComponent: CustomTooltip,
      cell: (row) =>
        row?.afterComments != "" && row?.afterComments != null ? (
          <div
            onClick={() => {
              setIsCommentModalShow(true);
              setCellClickData(row);
            }}
          >
            <img src={require("./../assets/Dashboard/comment.png")} />
          </div>
        ) : null,
    },
  ]);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let name = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.firstName
          : ""
        : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    if (getMoveData && getMoveData?.length > 0 && getMoveData != "Failed") {
      setLoading(false);
      if (
        loginResponse &&
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY &&
        loginResponse?.user?.userRoles[0]?.priority
      ) {
        let completedData = getMoveData.filter((item) => {
          return item.completed == true && item.user_id != null;
        });
        let rowDataArrCompleted = [...completedData];
        setRowDataCompleted(rowDataArrCompleted);

        let inProgressRequest = getMoveData.filter((item) => {
          return (
            item.pending != true &&
            item.completed != true &&
            item.user_id != null
          );
        });
        let rowDataArrInProgress = [...inProgressRequest];
        setRowDataInProgress(rowDataArrInProgress);

        if (inProgressRequest.length > 0) {
          setKeyData("InProgressRequest");
        } else if (rowDataArrCompleted.length > 0) {
          setKeyData("CompletedRequest");
        }
      } else {
        let completedData = getMoveData.filter((item) => {
          return (
            item.pending == false &&
            item.completed == true &&
            item.is_cancelled == false &&
            item?.division_id == divisionSelectedTemp?.value
          );
        });
        let rowDataArrCompleted = [...completedData];
        setRowDataCompleted(rowDataArrCompleted);

        let pendingData = getMoveData.filter((item) => {
          return (
            item.pending == true &&
            item.completed == false &&
            item.is_cancelled == false &&
            item?.division_id == divisionSelectedTemp?.value
          );
        });
        let rowDataArrPending = [...pendingData];
        setRowDataPending(rowDataArrPending);

        let pendingDataInProgress = getMoveData.filter((item) => {
          return (
            item.pending == false &&
            item.completed == false &&
            item.is_cancelled == false &&
            item?.division_id == divisionSelectedTemp?.value
          );
        });
        let rowDataArrInProgress = [...pendingDataInProgress];
        setRowDataInProgress(rowDataArrInProgress);

        let cancelledData = getMoveData.filter((item) => {
          return (
            item.pending == false &&
            item.completed == false &&
            item.is_cancelled == true &&
            item?.division_id == divisionSelectedTemp?.value
          );
        });
        let cancelledRowData = [...cancelledData];
        setRowDataCancelled(cancelledRowData);

        if (rowDataArrCompleted.length > 0) {
          setKeyData("CompletedRequest");
        } else if (pendingData.length > 0) {
          setKeyData("PendingRequest");
        } else if (pendingDataInProgress.length > 0) {
          setKeyData("InProgressRequest");
        } else {
          setKeyData("CancelledRequest");
        }
      }
    } else {
      setLoading(false);
    }
  }, [getMoveDatTemp]);

  useEffect(() => {
    setColumnDefs(columnDefsPending);
    setColumnDefsInProgress(columnDefsInProg);
    setColumnDefsCompleted(columnCompletedDefs);
    setColumnDefsCancelled(columnCancelledDefs);
  }, [loginResponse]);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let name = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.firstName
          : ""
        : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    setLoading(true);
    let obj = {
      moveType: 1,
      pageNo: 1,
      limit: pageLimit,
    };
    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
      payload: { value: obj },
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
        .GET_ACTIVE_USER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL,
    });
  }, []);

  const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  const deleteEmptyTrailerMove = (rowData) => {
    let payload = {
      move_id: rowData.move_id,
      user_id: rowData.user_id, // change to number
      division_id: rowData.division_id,
      changeType: rowData.changeType, //Move type
      requestDateTime: rowData.createdAt,
      requesterName: rowData.requesterName,
      trailer_id: rowData?.trailer_id,
      outsideCarrierContainer_id: rowData?.outsideCarrierContainer_id,
      doorToId: rowData.doorToId,
      doorFromId: rowData.doorFromId,
      spaceFromId: rowData.spaceFromId,
      spaceToId: rowData.spaceToId,
      locationFromId: rowData.locationFromId,
      locationToId: rowData.locationToId,
      department: rowData.department,
      productNum: rowData.productNum,
      actualCount: rowData.actualCount,
      sealNum: rowData.sealNum,
      startDateTime: rowData.createdAt,
      finishDateTime: null,
      beforeComments: rowData.beforeComments,
      afterComments: "",
      driver_id: rowData.driver_id,
      truck_id: rowData.truck_id,
      priorityMove: rowData.priorityMove, // true  false ,
      pending: rowData.pending,
      completed: rowData.completed,
      isEmpty: false,
      is_active: false,
    };

    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_CALL,
      payload: { value: payload },
    });
  };

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  const commentModalShow = (isShow) => {
    setIsCommentModalShow(isShow);
  };
  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
        .GET_TRAILER_MANAGEMENT_API_CALL,
    });
  }, [modalShow]);

  const conditionalRowStyles = [
    {
      when: (row) => row.pending,
      style: (row) => ({
        backgroundColor: row.Number % 2 == 0 ? "#FFFBCB" : "#FFFBCB",
        userSelect: "none",
      }),
    },
    {
      when: (row) => row.priorityMove,
      style: {
        backgroundColor: "#bff2cd",
        userSelect: "none",
      },
    },
    {
      when: (row) => row.isEmpty,
      style: {
        backgroundColor: "#98c0ed",
        userSelect: "none",
      },
    },
  ];

  const conditionalRowStylesInProgress = [
    {
      when: (row) => !row.pending && !row.completed,
      style: (row) => ({
        backgroundColor: row.Number % 2 == 0 ? "#EEFFBA" : "#EEFFBA",
        userSelect: "none",
      }),
    },
    {
      when: (row) => row.priorityMove,
      style: {
        backgroundColor: "#bff2cd",
        userSelect: "none",
      },
    },
    {
      when: (row) => row.isEmpty,
      style: {
        backgroundColor: "#98c0ed",
        userSelect: "none",
      },
    },
    {
      when: (row) => row.requestFlag === "Red Light",
      style: {
        backgroundColor: " #f56942",
        userSelect: "none",
      },
    },
  ];

  const conditionalRowStylesCancelled = [
    {
      when: (row) => row.priorityMove,
      style: {
        backgroundColor: "#bff2cd",
        userSelect: "none",
      },
    },
    {
      when: (row) => row.requestFlag === "Red Light",
      style: {
        backgroundColor: " #f56942",
        userSelect: "none",
      },
    },
  ];

  const handlePageChange = (pageNo) => {
    setLoading(true);
    let obj = {
      moveType:
        keyData.toLowerCase() == "pendingrequest"
          ? 1
          : keyData.toLowerCase() == "inprogressrequest"
          ? 2
          : keyData.toLowerCase() == "completedrequest"
          ? 3
          : 4,
      pageNo: pageNo,
      limit: perPage,
    };
    if (!loading)
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
        payload: { value: obj },
      });

    setCurrentPage(pageNo);
  };

  const handlePerRowsChange = async (newPerPage, pageNo) => {
    setLoading(true);
    if (keyData.toLowerCase() == "pendingrequest") {
      let obj = {
        moveType: 1,
        pageNo: pageNo,
        limit: newPerPage,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
        payload: { value: obj },
      });
    } else if (keyData.toLowerCase() == "inprogressrequest") {
      let obj = {
        moveType: 2,
        pageNo: pageNo,
        limit: newPerPage,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
        payload: { value: obj },
      });
    } else if (keyData.toLowerCase() == "completedrequest") {
      let obj = {
        moveType: 3,
        pageNo: pageNo,
        limit: newPerPage,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
        payload: { value: obj },
      });
    } else {
      let obj = {
        moveType: 4,
        pageNo: pageNo,
        limit: newPerPage,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
        payload: { value: obj },
      });
    }
    setPerPage(newPerPage);
  };

  return (
    <div className="row">
      {isCommentModalShow ? (
        <CommentModalComp
          title={"Comment"}
          show={commentModalShow}
          handleClose={commentModalShow}
          comment={
            (cellData?.completed || cellData?.is_cancelled) &&
            cellData?.afterComments != "" &&
            cellData?.afterComments != null
              ? cellData?.afterComments
              : cellData?.beforeComments
          }
        />
      ) : null}
      {modalShow ? (
        <MovesModalComponent
          title={title ? title : "Create New Move"}
          keyTitle={keyTitle}
          show={showModal}
          handleClose={showModal}
          rowId={rowId}
          isUpdate={isUpdateMove}
          lotManagement={true}
          isShow={showModal}
          rowDataUser={cellData}
          keyData={keyData}
          setValue={(value) => {
            isModalShow(false);
            if (cellData != null) {
              setCellClickData(null);
              setKeyData("");
              if (
                value.driver_id != undefined &&
                value.driver_id != null &&
                value.driver_id != "" &&
                value.move_id &&
                keyData.toLowerCase() == "pendingrequest"
              ) {
                value.pending = 0;
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .UPDATE_MOVES_API_CALL,
                  payload: { value: value },
                });
              } else {
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .UPDATE_MOVES_API_CALL,
                  payload: { value: value },
                });
              }
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      <div className="col-md-12 col-sm-12 col-12">
        <p data-tip="tooltip"></p>
        {
          <div
            onClick={() => {
              setCellClickData(null);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            <div className="ms-md-auto pe-md-3 d-flex align-items-center">
              <div className="input-group">
                <span className="input-group-text text-body">
                  <i className="fas fa-search" aria-hidden="false"></i>
                </span>
                <input
                  aria-label="Search"
                  autoComplete={"false"}
                  data-html={true}
                  data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                    &amp;#8226; Include both lowercase and uppercase characters.<br />
                                    &amp;#8226; Include atleast one number or symbol.<br />
                                    &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                  aria-describedby="basic-addon2"
                  type="text"
                  className="form-control"
                  placeholder="Type here..."
                  onChange={(value) => {
                    let filterData = [];
                    if (value.target?.value == "") {
                      filterData = getMoveData;
                    } else {
                      filterData = getMoveData.filter((item) => {
                        return (
                          item.requesterName
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.changeType
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.trailer?.btId
                            ?.toLowerCase()
                            ?.includes(value.target.value) ||
                          item.trailer?.designationLocation
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.trailer?.currentLoad
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.trailer?.previousLocation
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.trailer?.currentLocation
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.trailer?.status
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.department
                            ?.toLowerCase()
                            ?.includes(value.target.value?.toLowerCase()) ||
                          item.requestFlag
                            ?.toLowerCase()
                            .includes(value.target.value?.toLowerCase())
                        );
                      });
                    }
                    if (filterData.length > 0) {
                      let completedData = filterData.filter((item) => {
                        return (
                          item.pending == false &&
                          item.completed == true &&
                          item.is_cancelled == false
                        );
                      });
                      let rowDataArrCompleted = [...completedData];
                      setRowDataCompleted(rowDataArrCompleted);

                      let pendingData = filterData.filter((item) => {
                        return (
                          item.pending == true &&
                          item.completed == false &&
                          item.is_cancelled == false
                        );
                      });
                      let rowDataArrPending = [...pendingData];
                      setRowDataPending(rowDataArrPending);

                      let pendingDataInProgress = filterData.filter((item) => {
                        return (
                          item.pending == false &&
                          item.completed == false &&
                          item.is_cancelled == false
                        );
                      });
                      let rowDataArrInProgress = [...pendingDataInProgress];
                      setRowDataInProgress(rowDataArrInProgress);

                      let cancelledData = filterData.filter((item) => {
                        return (
                          item.pending == false &&
                          item.completed == false &&
                          item.is_cancelled == true
                        );
                      });
                      let cancelledRowData = [...cancelledData];
                      setRowDataCancelled(cancelledRowData);

                      if (rowDataArrCompleted.length > 0) {
                        setKeyData("CompletedRequest");
                      } else if (pendingData.length > 0) {
                        setKeyData("PendingRequest");
                      } else if (pendingDataInProgress.length > 0) {
                        setKeyData("InProgressRequest");
                      } else {
                        setKeyData("CancelledRequest");
                      }
                    }
                  }}
                ></input>
              </div>
            </div>
            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH &&
                loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <img
                onClick={() => {
                  setTitle("Create New Move");
                  setCellClickData(null);
                  setKeyData("PendingRequest");
                  setIsUpdate(false);
                  isModalShow(true);
                }}
                src={require("./../assets/Dashboard/plus.png")}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              ></img>
            ) : null}
          </div>
        }
        <div>
          <Tabs
            defaultActiveKey="PendingRequest"
            activeKey={keyData}
            transition={true}
            onSelect={(k) => {
              setKey(k);
              setKeyData(k);
              setLoading(true);
              if (k.toLowerCase() == "pendingrequest") {
                let obj = {
                  moveType: 1,
                  pageNo: pageNo,
                  limit: perPage,
                };
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .GET_MOVES_BY_TYPES_API_CALL,
                  payload: { value: obj },
                });
              } else if (k.toLowerCase() == "inprogressrequest") {
                let obj = {
                  moveType: 2,
                  pageNo: pageNo,
                  limit: perPage,
                };
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .GET_MOVES_BY_TYPES_API_CALL,
                  payload: { value: obj },
                });
              } else if (k.toLowerCase() == "completedrequest") {
                let obj = {
                  moveType: 3,
                  pageNo: pageNo,
                  limit: perPage,
                };
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .GET_MOVES_BY_TYPES_API_CALL,
                  payload: { value: obj },
                });
              } else if (k.toLowerCase() == "cancelledrequest") {
                let obj = {
                  moveType: 4,
                  pageNo: pageNo,
                  limit: perPage,
                };
                dispatch({
                  type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                    .GET_MOVES_BY_TYPES_API_CALL,
                  payload: { value: obj },
                });
              }
            }}
            id="fill-tab-example"
            className="mt-3"
            justify
          >
            <Tab
              className={{
                display: "block",
                padding: "0.5rem 1rem",
                color: "black",
                transition:
                  "color 0.15s ease-in-out, backgroundolor 0.15s ease-in-out, border-color 0.15s ease-in-out",
              }}
              eventKey="PendingRequest"
              title="Pending Request"
            >
              <div className="example-wrapper">
                <div
                  className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
                  style={{
                    height: "60vh",
                    width: "80vw",
                    margin: "auto",
                  }}
                >
                  <DataTable
                    ref={gridRef}
                    getRowClassName={(params) =>
                      `super-app-theme--${params.row.status}`
                    }
                    columns={columnDefs}
                    data={rowDataPending}
                    responsive={true}
                    tooltipShowDelay={0}
                    tooltipHideDelay={2000}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={moveCount}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    selectableRows
                    conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </div>
            </Tab>

            <Tab eventKey="InProgressRequest" title="InProgress Request">
              <div
                className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
                style={{
                  height: "60vh",
                  width: "80vw",
                  margin: "auto",
                }}
              >
                <DataTable
                  ref={gridRef}
                  columns={columnDefsInProgress}
                  data={rowDataInProgress}
                  responsive={true}
                  tooltipShowDelay={0}
                  tooltipHideDelay={2000}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={moveCount}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  selectableRows
                  conditionalRowStyles={conditionalRowStylesInProgress}
                />
              </div>
            </Tab>

            <Tab eventKey="CompletedRequest" title="Completed Request">
              <div
                className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
                style={{
                  height: "60vh",
                  width: "80vw",
                  margin: "auto",
                }}
              >
                <DataTable
                  ref={gridRef}
                  columns={columnCompletedDefs}
                  data={rowDataCompleted}
                  responsive={true}
                  tooltipShowDelay={0}
                  tooltipHideDelay={2000}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={moveCount}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  selectableRows
                  conditionalRowStyles={conditionalRowStylesInProgress}
                />
              </div>
            </Tab>

            <Tab eventKey="CancelledRequest" title="Cancelled Request">
              <div
                className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4"
                style={{
                  height: "60vh",
                  width: "80vw",
                  margin: "auto",
                }}
              >
                <DataTable
                  ref={gridRef}
                  columns={columnCancelledDefs}
                  data={rowDataCancelled}
                  responsive={true}
                  tooltipShowDelay={0}
                  tooltipHideDelay={2000}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={moveCount}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  selectableRows
                  conditionalRowStyles={conditionalRowStylesCancelled}
                />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default MovesComp;
